import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as styles from "../styleguide/styles/Stylesheet.js";
import Donations from "./game/components/Donations.js";

const FooterBar = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${styles.color_white};
  display: flex;
  justify-content: center;
  z-index: 1;
`;

const FooterInner = styled.div`
  width: 100%;
  max-width: ${styles.width_md};
  padding: ${styles.spacing_standard_large} ${styles.spacing_standard};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${styles.spacing_standard};
`;

const FooterCopy = styled.div`
  font-family: ${styles.font_sans};
  font-size: 16px;
  color: ${styles.color_accent};
  text-align: center;
`;

const EmailLink = styled.a`
  font-family: ${styles.font_sans};
  font-size: 16px;
  color: ${styles.color_accent};
  margin: 0 0 0 4px;
  transition: 200ms color;

  &:hover {
    color: ${styles.color_accent_dark};
  }
`;

const SmallCopy = styled.div`
  font-family: ${styles.font_sans};
  font-size: 13px;
  color: ${styles.color_gry_4};
  text-align: center;
`;

const FooterLink = styled(Link)`
  font-family: ${styles.font_sans};
  font-size: 13px;
  color: ${styles.color_gry_4};
  margin: 0 0 0 4px;
  transition: 200ms color;

  &:hover {
    color: ${styles.color_accent};
  }
`;

export default function Footer() {
  const year = new Date().getFullYear();
  const email = "summercampslashergame@gmail.com";
  return (
    <FooterBar role="contentinfo" aria-label="Site footer">
      <Donations />
      <FooterInner>
        <FooterCopy>
          Questions, suggestions, or bugs? Contact
          <EmailLink href={`mailto:${email}`}>{email}</EmailLink>
        </FooterCopy>
        <SmallCopy>
          © {year} Summer Camp Slasher |
          <FooterLink target="_blank" to="/privacy">
            Privacy Policy
          </FooterLink>{" "}
          |
          <FooterLink target="_blank" to="/terms-of-service">
            Terms of Service
          </FooterLink>{" "}
          |<FooterLink to="/">Home</FooterLink>
        </SmallCopy>
      </FooterInner>
    </FooterBar>
  );
}
